(function ($) {

	$('.m-filter input, .m-filter select').change(function () {
		$(this).closest("form").submit();
	});

})(jQuery);